import React from 'react';
import style from '../css/Gallery.module.css';

import img1 from '../images/gallery/img1.png';
import img2 from '../images/gallery/img2.png';
import video1 from '../images/gallery/video1.mp4';
import video2 from '../images/gallery/video2.mp4';
import videoVertical from '../images/gallery/video_vertical.mp4';

const Gallery = () => {
	return (
		<section className={style.mainSection}>
			<div className={style.mainContainer}>
				<div className={style.bubble}>
					<span>Se parte de la comunidad LIBEL</span>
				</div>

				<h1>RESULTADOS DE ALUMNOS</h1>
				<div className={style.grid}>
					<div className={style.gallery1}>
						<video src={video1} autoPlay loop muted playsInline alt='1'></video>
						<div className={style.alumno1}>
							<h1>Alumn@: Armando Andre Dulanto.</h1>
						</div>
					</div>
					<div className={style.gallery2}>
						<img src={img1} alt='1' />
						<div className={style.alumno2}>
							<h1>Alumn@: Joan Sebastian.</h1>
						</div>
					</div>
					<div className={style.gallery3}>
						<video src={videoVertical} autoPlay loop muted playsInline alt='vertical'></video>
						<div className={style.alumno3}>
							<h1>Alumn@: Andrea Chitiva.</h1>
						</div>
					</div>
					<div className={style.gallery4}>
						<img src={img2} alt='2' />
						<div className={style.alumno4}>
							<h1>Alumn@: Lurkingpengu.</h1>
						</div>
					</div>
					<div className={style.gallery5}>
						<video src={video2} autoPlay loop muted playsInline alt='2'></video>
						<div className={style.alumno5}>
							<h1>Alumn@: Camilo Cárdenas.</h1>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Gallery;
